import api from './axios';

/** Whether the feature is on is decided by the server (`PERFORMANCE_REVIEW_ENABLED` + `GET /performance-review/status`). */
export function getPerformanceReviewStatus() {
  return api.get('/performance-review/status').then((r) => r.data);
}

/** Admin / superadmin — creates or upserts a calendar cycle (year + quarter 1–4). */
export function createPerformanceReviewCycle(body) {
  return api.post('/performance-review/cycles', body).then((r) => r.data);
}

export function getPerformanceReviewMe(year, quarter) {
  return api
    .get('/performance-review/me', { params: { year, quarter } })
    .then((r) => r.data);
}

export function putPerformanceReviewMe(body) {
  return api.put('/performance-review/me', body).then((r) => r.data);
}

export function submitPerformanceReviewMe(body) {
  return api.post('/performance-review/me/submit', body).then((r) => r.data);
}

export function getPerformanceReviewEmployee(userId, params) {
  return api.get(`/performance-review/employee/${userId}`, { params }).then((r) => r.data);
}

export function putPerformanceReviewManager(submissionId, body) {
  return api
    .put(`/performance-review/submissions/${submissionId}/manager`, body)
    .then((r) => r.data);
}

export function requestPerformanceReviewRevision(submissionId, body) {
  return api
    .post(`/performance-review/submissions/${submissionId}/request-revision`, body)
    .then((r) => r.data);
}

export function publishPerformanceReview(submissionId) {
  return api.post(`/performance-review/submissions/${submissionId}/publish`).then((r) => r.data);
}

export function putPerformanceReviewSuperAdmin(submissionId, body) {
  return api
    .put(`/performance-review/submissions/${submissionId}/superadmin`, body)
    .then((r) => r.data);
}

export function patchPerformanceReviewSuperadminVisibility(submissionId, visible) {
  return api
    .patch(`/performance-review/submissions/${submissionId}/superadmin-visibility`, { visible })
    .then((r) => r.data);
}
